// https://en.wikipedia.org/wiki/E.164
// converted from TS in rt-vue (this original on rt-vue was NOT TS!)
const sanitize = (number) => number.replace(/[()\-_.\s]/g, '')

// stupid simple formatter, we just ignore +1 and whatever else is at the beginning
function dashFormat(number) {
    const num = sanitize(number)

    // Do not format if its not in E164 format
    // +1.7013678810
    if (!num.includes('+1')) return number

    const areaCode = num.substr(-10, 3) // 701
    const prefix = num.substr(-7, 3) // 367
    const local = num.substr(-4) // 8810

    return `${areaCode}-${prefix}-${local}` // 701-367-8810
}

function e164Format(number) {
    const num = sanitize(number)
    if (num.indexOf('+') === 0 || num.length !== 10) return number
    else return '+1' + num
}

export { dashFormat, e164Format }
